module.exports = __webpack_public_path__ + "components/MapControl/svg/Wieża widokowa.svg?39d1ee40";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Wieża widokowa.svg
// module id = 2089
// module chunks = 0